import {
  TextField,
  InputAdornment,
  IconButton,
  OutlinedTextFieldProps,
  Tooltip,
} from "@mui/material";
import React from "react";
import { BiSearch } from "react-icons/bi";

interface Props extends OutlinedTextFieldProps {
  handleBtnSearch: () => void;
  disableButton?: boolean;
  tooltip?: string;
}

const InputGrid: React.FC<Props> = ({
  handleBtnSearch,
  disableButton,
  tooltip,
  ...rest
}) => {
  return (
    <TextField
      label=""
      placeholder="Pesquisar..."
      size="small"
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {tooltip ? (
              <Tooltip title={tooltip} arrow placement="top" followCursor>
                <IconButton
                  onClick={() => handleBtnSearch()}
                  style={{
                    backgroundColor: `#2D5BFF${disableButton ? "80" : ""}`,
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: 0,
                    height: 36,
                  }}
                  disabled={disableButton}
                >
                  <BiSearch color="#ffffff" size={22} />
                </IconButton>
              </Tooltip>
            ) : (
              <IconButton
                onClick={() => handleBtnSearch()}
                style={{
                  backgroundColor: `#2D5BFF${disableButton ? "80" : ""}`,
                  borderTopRightRadius: 8,
                  borderBottomRightRadius: 8,
                  borderBottomLeftRadius: 0,
                  borderTopLeftRadius: 0,
                  height: 36,
                }}
                disabled={disableButton}
              >
                <BiSearch color="#ffffff" size={22} />
              </IconButton>
            )}
          </InputAdornment>
        ),
        sx: {
          height: "36px",
          paddingRight: 0,
          borderRadius: 2,
          borderColor: "#ECECEC",
          borderWidth: 1.5,
        },
      }}
      {...rest}
    />
  );
};

export default InputGrid;
